import countries from "../../../../data/countries.json"
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {UiSelect} from "../../../ui-components/select/uiSelect";
import {UiOption} from "../../../ui-components/select/option/uiOption";
import {UiFlag} from "../../../ui-components/flag/UiFlag";
import {UiInput} from "../../../ui-components/input/uiInput";
import {UiInputPassword} from "../../../ui-components/inputPassword/UiInputPassword";
import {LoginErrors} from "../login";


type RegisterFormType = {
    setMail: (mail: string) => void,
    setCountry: (country: string) => void,
    setPassword: (password: string) => void,
    setTitle: (title: string) => void,
    country: string,
    errors: LoginErrors,
    onSubmit: (event: React.FormEvent<HTMLInputElement>) => void,
}

export const RegisterForm: React.FC<RegisterFormType> = (props) => {
    const { t } = useTranslation()

    useEffect(() => {
        props.setTitle(t("login.register-yourself-on-Fastype"));
    }, []);

    return (
        <>
            <div className="flex flex-col gap-12">
                <div className="flex flex-col gap-6">
                    <div className="h-16">
                        <UiInput
                            placeholder={t("form.email")}
                            onChange={(event) => {
                                props.setMail((event.target as HTMLInputElement).value)
                            }}
                            isOnError={props.errors.mailIsOnError}
                        />
                        {props.errors.mailIsOnError &&
                            <p className="text-danger">{props.errors.mailErrorMessage}</p>
                        }
                    </div>

                    <div className="w-full h-16">
                        <UiSelect
                            searchPlaceholder={t("form.country")}
                            onOpenClearSearch={true}
                            onChange={(value: string) => {
                                props.setCountry(value)
                            }}
                            onError={props.errors.countryIsOnError}
                        >
                            {countries.map((countryCode) => {
                                return <UiOption
                                    value={countryCode}
                                    searchData={t(`countries.${countryCode}`)}
                                    key={countryCode}
                                >
                                    <div className="flex gap-3 items-center">
                                        <UiFlag
                                            className="min-w-8 h-5"
                                            countryCode={countryCode}
                                            showTooltip={false}
                                        />
                                        <p>{t(`countries.${countryCode}`)}</p>
                                    </div>
                                </UiOption>
                            })}
                        </UiSelect>

                        {props.errors.countryIsOnError &&
                            <p className="text-danger">{props.errors.countryErrorMessage}</p>
                        }
                    </div>

                    <div className="h-16">
                        <UiInputPassword
                            placeholder={t("form.password")}
                            onChange={(event) => {
                                props.setPassword((event.target as HTMLInputElement).value)
                            }}
                            isOnError={props.errors.passwordIsOnError}
                            onSubmit={props.onSubmit}
                        />
                        {props.errors.passwordIsOnError &&
                            <p className="text-danger">{props.errors.passwordErrorMessage}</p>
                        }
                    </div>

                </div>
            </div>
        </>
    )
}
